module.exports = __webpack_public_path__ + "static/img/NP@3x.e7d67baf.jpg";